(() => {
	let shippingInfoElement = document.querySelector('.js-shipping-info2');
	let buttonElement = document.querySelector('.js-pdp-logo__button');
	let tooltipElement = document.querySelector('.js-pdp-logo__tooltip');
	let closeButtonElement = document.querySelector('.tooltip__close');
	let descriptionElement = document.querySelector('.js-logo-desc');
	let isTooltipOpen = false;

	if (shippingInfoElement) {
		let currentDate = new Date();
		let timezoneOffsetMinutes = currentDate.getTimezoneOffset();
		let timezoneOffsetHours = timezoneOffsetMinutes / 60;

		if (timezoneOffsetHours == 7 || timezoneOffsetHours == 6 || timezoneOffsetHours == 5) {
			shippingInfoElement.classList.add('shipping-info--hidden');
			descriptionElement.classList.add('logo-desc--hide');
			buttonElement.classList.add('pdp-logo__button--show');
		}

		function calculateDeliveryDate() {
			let estimatedDate = new Date();
			let currentEstimateDate = new Date();
			let timezoneOffset = estimatedDate.getTimezoneOffset();

			estimatedDate.setMinutes(estimatedDate.getMinutes() + timezoneOffset);
			currentEstimateDate.setMinutes(currentEstimateDate.getMinutes() + timezoneOffset);

			estimatedDate.setHours(estimatedDate.getHours() - 5);
			currentEstimateDate.setHours(currentEstimateDate.getHours() - 5);

			let deliveryDate = estimatedDate;
			let currentDate = currentEstimateDate;

			deliveryDate.setHours(14, 0, 0, 0);

			if (currentDate.getDay() > 0 && currentDate.getDay() < 5 && currentDate.getHours() <= 14) {
				deliveryDate.setDate(deliveryDate.getDate() + 1);
			} else if (currentDate.getDay() > 0 && currentDate.getDay() < 5 && currentDate.getHours() >= 14) {
				deliveryDate.setDate(deliveryDate.getDate() + 2);
			} else if (currentDate.getDay() === 5 && currentDate.getHours() <= 14) {
				deliveryDate.setDate(deliveryDate.getDate() + 3);
			} else if (currentDate.getDay() === 5 && currentDate.getHours() >= 14) {
				deliveryDate.setDate(deliveryDate.getDate() + 4);
			} else if (currentDate.getDay() === 6) {
				deliveryDate.setDate(deliveryDate.getDate() + 4);
			} else if (currentDate.getDay() === 0) {
				deliveryDate.setDate(deliveryDate.getDate() + 3);
			}

			let deliveryMonth = (deliveryDate.getMonth() + 1).toString().padStart(2, '0');
			let deliveryDay = deliveryDate.getDate().toString().padStart(2, '0');
			let formattedDeliveryDate = `${deliveryMonth}/${deliveryDay}`;

			return formattedDeliveryDate;
		}

		function updateCountdownTimer() {
			let currentDate = new Date();
			let deliveryDate = new Date();
			deliveryDate.setHours(14, 0, 0, 0);

			if (currentDate.getDay() > 0 && currentDate.getDay() < 5 && currentDate.getHours() <= 14) {
				deliveryDate.setDate(deliveryDate.getDate());
			} else if (currentDate.getDay() > 0 && currentDate.getDay() < 5 && currentDate.getHours() >= 14) {
				deliveryDate.setDate(deliveryDate.getDate() + 1);
			} else if (currentDate.getDay() === 5 && currentDate.getHours() <= 14) {
				deliveryDate.setDate(deliveryDate.getDate());
			} else if (currentDate.getDay() === 5 && currentDate.getHours() >= 14) {
				deliveryDate.setDate(deliveryDate.getDate() + 3);
			} else if (currentDate.getDay() === 6) {
				deliveryDate.setDate(deliveryDate.getDate() + 3);
			} else if (currentDate.getDay() === 0) {
				deliveryDate.setDate(deliveryDate.getDate() + 2);
			}

			let timeDifference = deliveryDate.getTime() - currentDate.getTime();
			let secondsRemaining = Math.floor(timeDifference / 1000);
			let hours = Math.floor(secondsRemaining / 3600);
			let minutes = Math.floor((secondsRemaining % 3600) / 60);

			document.querySelector('.js-coutdown2').textContent = hours.toString().padStart(2, '0');
		}

		function updateDeliveryInfo() {
			let deliveryDate = calculateDeliveryDate();
			document.querySelector('.js-delivery2').textContent = deliveryDate;

			updateCountdownTimer();
			setInterval(updateCountdownTimer, 10000);
		}

		updateDeliveryInfo();
	}

	if (tooltipElement) {
		tooltipElement.addEventListener('click', function (event) {
			event.stopPropagation();
		});
	}

	if (buttonElement) {
		buttonElement.addEventListener('click', function (event) {
			event.stopPropagation();
			if (!isTooltipOpen) {
				tooltipElement.classList.add('pdp-logo__tooltip--active');
				isTooltipOpen = true;
				document.addEventListener('click', hideTooltip);
			} else {
				tooltipElement.classList.remove('pdp-logo__tooltip--active');
				isTooltipOpen = false;
				document.removeEventListener('click', hideTooltip);
			}
		});
	}

	if (closeButtonElement) {
		closeButtonElement.addEventListener('click', function (event) {
			event.stopPropagation();
			tooltipElement.classList.remove('pdp-logo__tooltip--active');
			isTooltipOpen = false;
			document.removeEventListener('click', hideTooltip);
		});
	}

	function hideTooltip() {
		tooltipElement.classList.remove('pdp-logo__tooltip--active');
		isTooltipOpen = false;
		document.removeEventListener('click', hideTooltip);
	}
})();
